import { render, staticRenderFns } from "./ListGift.vue?vue&type=template&id=6179040a&scoped=true"
import script from "./ListGift.vue?vue&type=script&lang=js"
export * from "./ListGift.vue?vue&type=script&lang=js"
import style0 from "./ListGift.vue?vue&type=style&index=0&id=6179040a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6179040a",
  null
  
)

export default component.exports